import { render, staticRenderFns } from "./BibliotecaView.vue?vue&type=template&id=506e8867&scoped=true"
import script from "./BibliotecaView.vue?vue&type=script&lang=js"
export * from "./BibliotecaView.vue?vue&type=script&lang=js"
import style0 from "./BibliotecaView.vue?vue&type=style&index=0&id=506e8867&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e8867",
  null
  
)

export default component.exports